import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Show consent banner after a short initial render delay
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="position-fixed bottom-0 start-0 end-0 pb-3 pb-md-4 z-3 d-flex justify-content-center"
      style={{ zIndex: 1080, pointerEvents: 'none' }}
    >
      <div 
        className="shadow-lg border rounded-3 p-3 p-md-3 text-main"
        style={{
          width: '90%',
          maxWidth: '90%',
          backgroundColor: 'var(--bg-card, #ffffff)',
          borderColor: 'var(--border-color, #e2e8f0)',
          borderRadius: '14px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.18)',
          pointerEvents: 'auto'
        }}
      >
        <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
          <div className="d-flex align-items-center gap-3">
            <div className="p-2 bg-primary bg-opacity-10 text-primary rounded-circle d-none d-sm-flex align-items-center justify-content-center flex-shrink-0" style={{ width: '42px', height: '42px' }}>
              <i className="bi bi-shield-check fs-4"></i>
            </div>
            <div>
              <div className="d-flex align-items-center gap-2 mb-1 flex-wrap">
                <span className="badge bg-primary text-uppercase" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>DPDP Act 2023 Compliance</span>
                <span className="fw-bold text-main text-sm">Privacy & Local Data Storage Notice</span>
              </div>
              <p className="text-muted text-xs mb-0" style={{ lineHeight: '1.5' }}>
                This portal utilizes essential browser local storage and cookies to maintain authenticated session tokens, 
                preserve user interface preferences, and securely cache running staff operational rosters. All personal information 
                is protected and governed strictly under India's <strong>Digital Personal Data Protection (DPDP) Act, 2023</strong>.
              </p>
            </div>
          </div>
          <div className="d-flex align-items-center gap-2 flex-shrink-0 justify-content-end">
            <Link 
              to="/PrivacyPolicy" 
              className="btn btn-sm btn-outline-secondary text-xs px-3 py-2 fw-medium"
              onClick={() => setIsVisible(false)}
            >
              Privacy Policy
            </Link>
            <button 
              type="button" 
              className="btn btn-sm btn-primary-custom text-xs px-4 py-2 fw-semibold"
              onClick={handleAccept}
            >
              <i className="bi bi-check2-circle me-1"></i> Acknowledge & Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
